import { ExpectedFileColumn } from "../../app/models/requestModels/fileExpectedColumn";

export enum FDP_COLUMN_NAME {
  ID = "id",
  COMAPANY_NAME = "companyName",
  DISPATCHER_NAME = "dispatcherName",
  OWNER_FIRSTNAME = "ownerFirstName",
  OWNER_LASTNAME = "ownerLastName",
  POINT_OF_CONTACT = "pointOfContact",
  PRIMARY_PHONE = "primaryPhone",
  SECONDARY_PHONE = "secondaryPhone",
  EMAIL = "email",
  PRIMARY_MSA = "primaryMsa",
  SECONDARY_MSA = "secondaryMsa",
  ADDRESS = "address",
  CITY = "city",
  STATE = "state",
  ZIP_CODE = "zipCode",
  ACTIVE = "active",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
}

export enum FDP_LABEL_NAME {
  ID = "Id",
  COMAPANY_NAME = "Company",
  DISPATCHER_NAME = "Dispatcher Name",
  OWNER_FIRSTNAME = "Owner FirstName",
  OWNER_LASTNAME = "Owner LastName",
  POINT_OF_CONTACT = "Point of contact",
  PRIMARY_PHONE = "Primary phone",
  SECONDARY_PHONE = "Secondary phone",
  EMAIL = "Email",
  PRIMARY_MSA = "Primary MSA",
  SECONDARY_MSA = "Secondary MSA",
  ADDRESS = "Address",
  CITY = "City",
  STATE = "State",
  ZIP_CODE = "Zipcode",
  ACTIVE = "Active",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
}

export const FDP_FILTER_COLUMN_OPTIONS = [
  {
    label: FDP_LABEL_NAME.COMAPANY_NAME,
    value: FDP_COLUMN_NAME.COMAPANY_NAME,
  },
  {
    label: FDP_LABEL_NAME.ACTIVE,
    value: FDP_COLUMN_NAME.ACTIVE,
  },
  {
    label: FDP_LABEL_NAME.DISPATCHER_NAME,
    value: FDP_COLUMN_NAME.DISPATCHER_NAME,
  },
  {
    label: FDP_LABEL_NAME.PRIMARY_PHONE,
    value: FDP_COLUMN_NAME.PRIMARY_PHONE,
  },
  {
    label: FDP_LABEL_NAME.PRIMARY_MSA,
    value: FDP_COLUMN_NAME.PRIMARY_MSA,
  },
  {
    label: FDP_LABEL_NAME.EMAIL,
    value: FDP_COLUMN_NAME.EMAIL,
  },
  {
    label: FDP_LABEL_NAME.CITY,
    value: FDP_COLUMN_NAME.CITY,
  },
  {
    label: FDP_LABEL_NAME.STATE,
    value: FDP_COLUMN_NAME.STATE,
  },
  {
    label: FDP_LABEL_NAME.ZIP_CODE,
    value: FDP_COLUMN_NAME.ZIP_CODE,
  },
];

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
export const zipcodeRegex = /^\d{5}(?:-\d{4})?$/;

export const STATES_LIST = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

const stateRegex = new RegExp(`\\b(${STATES_LIST.join('|')})\\b`);

export const FdpExpectedColumns: ExpectedFileColumn[] = [
  {
    name: "Company Name",
    mandatory: true,
    type: "string",
    camelCaseName: "companyName",
  },
  {
    name: "Dispatcher Name",
    mandatory: false,
    type: "string",
    camelCaseName: "dispatcherName",
  },
  {
    name: "Owner Firstname",
    mandatory: true,
    type: "string",
    camelCaseName: "ownerFirstName",
  },
  {
    name: "Owner Lastname",
    mandatory: false,
    type: "string",
    camelCaseName: "ownerLastName",
  },
  {
    name: "Primary Phone",
    mandatory: true,
    type: "string",
    regex: phoneRegex,
    camelCaseName: "primaryPhone",
  },
  {
    name: "Secondary Phone",
    mandatory: false,
    type: "string",
    regex: phoneRegex,
    camelCaseName: "secondaryPhone",
  },
  {
    name: "Primary MSA",
    mandatory: true,
    type: "string",
    camelCaseName: "primaryMsa",
  },
  {
    name: "Secondary MSA",
    mandatory: false,
    type: "string",
    camelCaseName: "secondaryMsa",
  },
  {
    name: "Email",
    mandatory: true,
    type: "string",
    regex: EMAIL_REGEX,
    camelCaseName: "email",
  },
  {
    name: "Address",
    mandatory: true,
    type: "string",
    camelCaseName: "address",
  },
  { name: "City", mandatory: true, type: "string", camelCaseName: "city" },
  {
    name: "State",
    mandatory: true,
    type: "string",
    regex: stateRegex,
    camelCaseName: "state",
  },
  {
    name: "Zipcode",
    mandatory: true,
    type: "string",
    regex: zipcodeRegex,
    camelCaseName: "zipCode",
  },
];